import API from "../api";

export const getZoomSettings = () =>
  API.get("/admin/integrations/zoom").then((r) => r.data);

export const saveZoomSettings = (payload) =>
  API.put("/admin/integrations/zoom", payload).then((r) => r.data);

export const connectZoom = (payload) =>
  API.post("/admin/integrations/zoom/connect", payload || {}, {
    timeout: 60000,
  }).then((r) => r.data);

export const disconnectZoom = () =>
  API.post("/admin/integrations/zoom/disconnect").then((r) => r.data);

export const clearZoomCredentials = () =>
  API.post("/admin/integrations/zoom/clear").then((r) => r.data);
